import React from 'react'
import HomeScreen from "../components/HomeScreen"
import AboutnMenu from "../components/AboutnMenu"
import HoursLocation from "../components/HoursLocation"
import Photos from "../components/Photos"
import Contact from "../components/Contact"
import styled from "styled-components"


const Body = styled.div`
  margin: 3rem 17rem;
  @media(max-width: 1600px){
  margin: 3rem 10rem;
  }
  @media(max-width: 1400px){
  margin: 3rem 8rem;
  }
  @media(max-width: 1100px){
  margin: 3rem 4rem;
  }
`

function Homepage() {
    return (
      <>
        <HomeScreen />
        <Body>
          <AboutnMenu />
          <HoursLocation />
          <Photos />
          <Contact />
        </Body>
      </>
    );
}

export default Homepage
